export const isLocationUk = location => {
    return location?.isUk !== false;
};
